import TransferApplicationPage from './TransferApplicationPage';

export default TransferApplicationPage;
